import { cn } from "@/lib/utils";

export const StatCard = ({ icon: Icon, label, value, sub, tint = "primary", className, ...props }) => {
  const tints = {
    primary: "bg-primary/10 text-primary",
    secondary: "bg-secondary/10 text-secondary",
    accent: "bg-accent/15 text-yellow-600",
    success: "bg-emerald-100 text-emerald-600",
  };
  return (
    <div
      className={cn(
        "bg-white p-5 rounded-3xl border border-slate-100 shadow-[0_4px_20px_rgba(0,0,0,0.03)]",
        "flex items-center gap-4 transition-transform hover:-translate-y-1",
        className,
      )}
      {...props}
    >
      {Icon && (
        <div className={cn("w-12 h-12 rounded-2xl flex items-center justify-center shrink-0", tints[tint])}>
          <Icon className="w-6 h-6" />
        </div>
      )}
      <div className="min-w-0">
        <div className="text-2xl font-extrabold text-slate-800 leading-tight">{value}</div>
        <div className="text-xs font-bold uppercase tracking-wide text-slate-400 truncate">{label}</div>
        {sub && <div className="text-xs text-slate-500 mt-0.5">{sub}</div>}
      </div>
    </div>
  );
};
